'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTestItemsForCatalog = exports.addTestItemsToCatalog = exports.getTestItem = exports.getTestCatalog = exports.getTestSeller = exports.getTestBidIncrementForCatalog = exports.getTestBiddingInfoForItem = exports.getTestItemFacets = exports.getTestCatalogDetails = exports.getTestItemDetails = exports.getTestBidHistory = exports.mockSimilarItems = exports.mockItems = exports.mockBiddingInfos = undefined;

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mockBiddingInfos = exports.mockBiddingInfos = [];
var mockBidHistories = [];
var mockBidIncrements = [];
var mockCatalogs = [];
var mockCatalogDetails = [];
var mockItemDetails = [];
var mockItemFacets = [];
var mockItems = exports.mockItems = [];
var mockSellers = [];
var mockSimilarItems = exports.mockSimilarItems = [{
    itemId: 32543804,
    similarItems: [32544155, 32544156, 32544355, 32544356, 32544357, 32544358]
}];

var lastId = 1000;
/* eslint-disable-next-line no-plusplus */
var getRandomId = function getRandomId() {
    return ++lastId;
};

var generateTestBidHistory = function generateTestBidHistory() {
    var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (itemId === 0) {
        itemId = getRandomId();
    }
    var data = {
        history: [{
            amount: 200,
            bidderId: 0,
            currency: 'USD',
            source: 'Competing Bid'
        }, {
            amount: 100,
            bidderId: 0,
            currency: 'USD',
            source: 'Competing Bid'
        }],
        itemId: itemId
    };
    mockBidHistories.push(data);
    return data;
};

var getTestBidHistory = exports.getTestBidHistory = function getTestBidHistory(itemId) {
    var data = (0, _find2.default)(mockBidHistories, function (x) {
        return x.itemId === itemId;
    });
    if (data) {
        return data;
    }
    return generateTestBidHistory(itemId);
};

var generateTestItemDetail = function generateTestItemDetail() {
    var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (itemId === 0) {
        itemId = getRandomId();
    }
    var data = {
        description: 'Test item description.',
        itemId: itemId
    };
    mockItemDetails.push(data);
    return data;
};

var getTestItemDetails = exports.getTestItemDetails = function getTestItemDetails(itemId) {
    var data = (0, _find2.default)(mockItemDetails, function (x) {
        return x.itemId === itemId;
    });
    if (data) {
        return data;
    }
    return generateTestItemDetail(itemId);
};

var generateTestCatalogDetail = function generateTestCatalogDetail() {
    var catalogId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (catalogId === 0) {
        catalogId = getRandomId();
    }
    var data = {
        catalogId: catalogId,
        customTerms: [],
        terms: 'Test terms.'
    };
    mockCatalogDetails.push(data);
    return data;
};

var getTestCatalogDetails = exports.getTestCatalogDetails = function getTestCatalogDetails(catalogId) {
    var data = (0, _find2.default)(mockCatalogDetails, function (x) {
        return x.catalogId === catalogId;
    });
    if (data) {
        return data;
    }
    return generateTestCatalogDetail(catalogId);
};

var generateTestItemFacets = function generateTestItemFacets() {
    var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (itemId === 0) {
        itemId = getRandomId();
    }
    var data = {
        categories: ['Paintings'],
        creators: [],
        itemId: itemId,
        materialsTechniques: ['Canvas', 'Oil'],
        origins: [],
        stylePeriods: []
    };
    mockItemFacets.push(data);
    return data;
};

var getTestItemFacets = exports.getTestItemFacets = function getTestItemFacets(itemId) {
    var data = (0, _find2.default)(mockItemFacets, function (x) {
        return x.itemId === itemId;
    });
    if (data) {
        return data;
    }
    return generateTestItemFacets(itemId);
};

var generateTestBiddingInfoForItem = function generateTestBiddingInfoForItem() {
    var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (itemId === 0) {
        itemId = getRandomId();
    }
    var data = {
        bidActivityCount: 0,
        bidCount: 0,
        bidderBidTimestamp: 0,
        bidderHasBid: false,
        bidderHasHighBid: false,
        bidderMaxBid: 0,
        isReserveMet: true,
        itemId: itemId,
        leadingBid: 0
    };
    mockBiddingInfos.push(data);
    return data;
};

var getTestBiddingInfoForItem = exports.getTestBiddingInfoForItem = function getTestBiddingInfoForItem(itemId) {
    var data = (0, _find2.default)(mockBiddingInfos, function (x) {
        return x.itemId === itemId;
    });
    if (data) {
        return data;
    }
    return generateTestBiddingInfoForItem(itemId);
};

var generateTestBidIncrementForCatalog = function generateTestBidIncrementForCatalog() {
    var catalogId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (catalogId === 0) {
        catalogId = getRandomId();
    }
    var data = {
        bidIncrements: [{ fromAmount: 0, incAmount: 1 }, { fromAmount: 30, incAmount: 2 }, { fromAmount: 100, incAmount: 5 }, { fromAmount: 500, incAmount: 10 }],
        catalogId: catalogId
    };
    mockBidIncrements.push(data);
    return data;
};

var getTestBidIncrementForCatalog = exports.getTestBidIncrementForCatalog = function getTestBidIncrementForCatalog(catalogId) {
    var data = (0, _find2.default)(mockBidIncrements, function (x) {
        return x.catalogId === catalogId;
    });
    if (data) {
        return data;
    }
    return generateTestBidIncrementForCatalog(catalogId);
};

var generateTestSeller = function generateTestSeller() {
    var sellerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (sellerId === 0) {
        sellerId = getRandomId();
    }
    var data = {
        address: 'Proshyan',
        address2: '',
        alias: 'arman-antiques-and-co',
        city: 'Yerervan',
        country: 'Armenia',
        countryCode: 'am',
        description: 'We are a multi-dealer shop dealing in antiques and collectibles.\r\n\r\nRussian, Asian, European Art and Decorative Art represented.',
        email: '2334_contact@liveauctioneers.com',
        logoId: 'armanantiques',
        name: 'Arman Antiques & Co',
        phoneNumber: '37491325310',
        regionCode: 'europe',
        sellerId: sellerId,
        stateCode: '',
        stateName: 'other',
        website: 'http://www.armandantiques.jimdo.com/',
        zip: '12'
    };
    mockSellers.push(data);
    return data;
};

var getTestSeller = exports.getTestSeller = function getTestSeller(sellerId) {
    var data = (0, _find2.default)(mockSellers, function (x) {
        return x.sellerId === sellerId;
    });
    if (data) {
        return data;
    }
    return generateTestSeller(sellerId);
};

var generateTestCatalog = function generateTestCatalog() {
    var catalogId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var sellerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (catalogId === 0) {
        catalogId = getRandomId();
    }
    if (sellerId === 0) {
        sellerId = getRandomId();
    }
    getTestSeller(sellerId);

    var catalog = {
        buyersPremium: {
            high: null,
            low: 0,
            lowCutoff: null,
            middle: null,
            middleCutoff: null
        },
        catalogId: catalogId,
        catalogStatus: 'live',
        currency: 'USD',
        description: 'Testing Follow Search Stuff',
        lotsListed: 50,
        paymentOptions: {
            'po-moneyorderaccepted': 'on',
            'po-wireaccepted': 'on',
            'so-shipwhere': 'worldwide',
            'sp-buyerpaysshippingactual': 'on'
        },
        preview: '',
        saleStartTs: 1460163600,
        sellerId: sellerId,
        title: 'Testing Follow Search'
    };
    mockCatalogs.push(catalog);
    return catalog;
};

var getTestCatalog = exports.getTestCatalog = function getTestCatalog(catalogId, sellerId) {
    var data = (0, _find2.default)(mockCatalogs, function (x) {
        return x.catalogId === catalogId;
    });
    if (data) {
        return data;
    }
    return generateTestCatalog(catalogId, sellerId);
};

var generateTestItem = function generateTestItem() {
    var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var catalogId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var sellerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (itemId === 0) {
        itemId = getRandomId();
    }
    if (catalogId === 0) {
        catalogId = getRandomId();
    }
    if (sellerId === 0) {
        sellerId = getRandomId();
    }
    getTestBiddingInfoForItem(itemId);
    getTestCatalog(catalogId);
    getTestSeller(sellerId);
    var item = {
        catalogId: catalogId,
        conditionReport: 'Good',
        highBidEstimate: 1200,
        imageVersion: 1451943886,
        isAvailable: true,
        isLocked: false,
        isPassed: false,
        isSold: false,
        itemId: itemId,
        lotNumber: '0016',
        lowBidEstimate: 100,
        photos: [1],
        salePrice: 0,
        sellerId: sellerId,
        soldType: 0,
        startPrice: 100,
        title: '20th + japanese + wedding + kimono'
    };
    mockItems.push(item);
    return item;
};

var getTestItem = exports.getTestItem = function getTestItem(itemId, catalogId, sellerId) {
    var data = (0, _find2.default)(mockItems, function (x) {
        return x.itemId === itemId;
    });
    if (data) {
        return data;
    }
    return generateTestItem(itemId, catalogId, sellerId);
};

var addTestItemsToCatalog = exports.addTestItemsToCatalog = function addTestItemsToCatalog(catalogId, count) {
    // eslint-disable-next-line no-plusplus
    for (var i = 0; i < count; i++) {
        getTestItem(0, catalogId);
    }
};

var getTestItemsForCatalog = exports.getTestItemsForCatalog = function getTestItemsForCatalog(catalogId) {
    var items = mockItems.filter(function (x) {
        return x.catalogId === catalogId;
    });
    if (items.length < 100) {
        addTestItemsToCatalog(catalogId, 100);
    }
    items = mockItems.filter(function (x) {
        return x.catalogId === catalogId;
    });
    return items;
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/mock/mockData.js
// module id = 6VmH
// module chunks = 46